import { z } from "zod";
import { PointVectorSchema } from "./catalog.js";
import { ConfidenceSchema, IdSchema, IsoTimestampSchema, NonEmptyStringSchema, NonNegativeIntegerSchema, SourceRefSchema, UnknownRecordSchema } from "./source.js";
export const RuleCardStatusSchema = z.enum([
    "draft",
    "active",
    "superseded",
    "disabled",
    "needs_clarification"
]);
export const RuleCardSchema = z
    .object({
    id: IdSchema,
    ruleSetId: IdSchema,
    title: NonEmptyStringSchema,
    originalText: NonEmptyStringSchema,
    enhancedText: NonEmptyStringSchema,
    tags: z.array(NonEmptyStringSchema),
    appliesTo: z.array(NonEmptyStringSchema),
    status: RuleCardStatusSchema,
    sourceRefs: z.array(SourceRefSchema).min(1),
    createdAt: IsoTimestampSchema,
    updatedAt: IsoTimestampSchema.optional()
})
    .strict();
export const RuleTraceSchema = z
    .object({
    id: IdSchema,
    ruleSetId: IdSchema,
    ruleCardId: IdSchema,
    stepId: IdSchema.optional(),
    inputHash: NonEmptyStringSchema.optional(),
    outputHash: NonEmptyStringSchema.optional(),
    summary: NonEmptyStringSchema,
    sourceRefs: z.array(SourceRefSchema).min(1),
    createdAt: IsoTimestampSchema
})
    .strict();
export const OpenRuleQuestionSchema = z
    .object({
    id: IdSchema,
    ruleSetId: IdSchema,
    title: NonEmptyStringSchema,
    question: NonEmptyStringSchema,
    defaultDisposition: z
        .object({
        disposition: NonEmptyStringSchema,
        rationale: NonEmptyStringSchema,
        sourceRefs: z.array(SourceRefSchema).optional()
    })
        .strict()
        .optional(),
    status: z.enum(["open", "answered", "deferred", "superseded"]),
    riskCategory: z.enum([
        "needsUserDecision",
        "catalog_gap",
        "requirement_conflict",
        "mapping_risk",
        "export_policy",
        "other"
    ]),
    relatedRuleCardIds: z.array(IdSchema),
    sourceRefs: z.array(SourceRefSchema).min(1),
    createdAt: IsoTimestampSchema
})
    .strict();
export const LoadProfileSchema = z
    .object({
    id: IdSchema,
    ruleSetId: IdSchema,
    key: NonEmptyStringSchema,
    label: NonEmptyStringSchema,
    pointDemand: PointVectorSchema,
    minQuantity: NonNegativeIntegerSchema,
    notes: z.array(NonEmptyStringSchema),
    sourceRefs: z.array(SourceRefSchema).min(1)
})
    .strict();
export const SelectorSchema = z
    .object({
    id: IdSchema,
    ruleSetId: IdSchema,
    key: NonEmptyStringSchema,
    description: NonEmptyStringSchema,
    candidates: z.array(IdSchema),
    selectedId: IdSchema.optional(),
    rationale: NonEmptyStringSchema,
    confidence: ConfidenceSchema,
    sourceRefs: z.array(SourceRefSchema).min(1)
})
    .strict();
export const ConstraintResultSchema = z
    .object({
    id: IdSchema,
    ruleSetId: IdSchema,
    constraintKey: NonEmptyStringSchema,
    status: z.enum(["pass", "warning", "fail", "not_applicable"]),
    subjectRef: IdSchema,
    message: NonEmptyStringSchema,
    details: UnknownRecordSchema,
    sourceRefs: z.array(SourceRefSchema),
    ruleTraceRefs: z.array(IdSchema)
})
    .strict()
    .superRefine((value, ctx) => {
    if (value.sourceRefs.length + value.ruleTraceRefs.length === 0) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: "constraint results require source or rule trace provenance",
            path: ["sourceRefs"]
        });
    }
});
export const RuleSetSchema = z
    .object({
    id: IdSchema,
    orgId: IdSchema,
    version: NonEmptyStringSchema,
    name: NonEmptyStringSchema,
    status: z.enum(["draft", "active", "superseded", "retired"]),
    ruleCards: z.array(RuleCardSchema),
    openQuestions: z.array(OpenRuleQuestionSchema),
    loadProfiles: z.array(LoadProfileSchema),
    sourceRefs: z.array(SourceRefSchema).min(1),
    createdAt: IsoTimestampSchema,
    activatedAt: IsoTimestampSchema.optional()
})
    .strict();
//# sourceMappingURL=rules.js.map